import client from "api/client";


const _client = client.route("/campaign");

const campaign = {
	getAll: () => _client.get(""),
	get: (payload) => _client.post("", payload),
	redeem: (payload) => _client.post("/redeem", payload)
};

export default campaign;